export default "__VITE_ASSET__4Nim9$L7__"